<template>
  <div class="card shadow-sm">
    <form id="formItems" class="needs-validation" novalidate>
      <div class="card-header">
        <h3 class="card-title" style="font-size: 20px; font-weight: bold">
          {{ $t("editproductgroup") }}
        </h3>
      </div>
      <div class="card-body">
        <div class="row text-sm-start d-flex justify-content-center mb-4">
          <div class="col-sm-5">
            <label for="selectMainProduct" class="form-label required">
              {{ $t("productgroupcode") }}</label
            >
            <input v-model="form.code" class="form-control mb-4" />
          </div>

          <div class="col-sm-5">
            <label for="selectMainProduct" class="form-label required">
              {{ $t("productgroupname") }}</label
            >
            <input v-model="form.name" class="form-control mb-4" />
          </div>
        </div>

        <div class="row text-end">
          <div class="col-sm-12">
            <button
              type="button"
              class="btn btn-sm btn-light btn-success"
              style="font-size: 14px; font-weight: bold"
              @click="openDialogSearchProcuct()"
            >
              {{ $t("addon") }}
            </button>
            <!-- <AddItem
              :dialogAddItem="dialogAddItem"
              :warehouseId="form.fromWarehouseId"
              @addProduct="addProduct"
              @closeDialogAddItem="closeDialogAddItem"
            /> -->
            <DialogSearchProduct
              :dialogSearchProduct="dialogSearchProduct"
              @closeDialogSearchProduct="closeDialogSearchProduct"
              @submitSearchProduct="submitSearchProduct"
              :warehouseId="form.fromWarehouseId"
            />
          </div>
        </div>

        <div class="table-responsive" style="padding-top: 3px">
          <table
            class="table table-hover table-rounded table-striped border gy-7 gs-7"
          >
            <thead>
              <tr
                style="width: 100%"
                class="fw-bold fs-5 text-gray-800 border-bottom-2 border-gray-200 mw-200px"
              >
                <th>{{ $t("no") }}</th>
                <th>{{ $t("productcode") }}</th>
                <th>{{ $t("productname") }}</th>
                <!-- <th>{{ $t("amount") }}(กล่อง)</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-if="dataItemsShow.length < 1">
                <td class="text-center" colspan="6">ไม่มีข้อมูล</td>
              </tr>
              <tr v-for="(item, index) in dataItemsShow" :key="index">
                <td>{{ !showing1 ? index + 1 : showing1 + index }}</td>
                <td>{{ item.code || item.product.code }}</td>
                <td>{{ item.name || item.product.name }}</td>
                <!-- <td>{{ item.stockAmt }}</td> -->
                <td>
                  <div>
                    <button
                      type="button"
                      class="btn btn-link btn-color-muted btn-active-color-danger m-0 p-0"
                      @click="confirmDelete(item, index)"
                    >
                      <i class="bi bi-trash3-fill"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- <div class="row d-flex justify-content-center mt-4">
          <div class="col-sm-8">
            <label for="selectMainProduct" class="form-label">หมายเหตุ</label>
            <input class="form-control mb-4" />
            <label for="selectMainProduct" class="form-label"
              >โอนเข้าคลัง</label
            >
            <input class="form-control mb-4" />
          </div>

          <div class="col-sm-4">
            <label for="selectMainProduct" class="form-label"
              >มูลค่ารวม(ก่อนVAT)</label
            >
            <input disabled class="form-control mb-4" />

            <label for="selectMainProduct" class="form-label">ส่วนลดรวม</label>
            <input disabled class="form-control mb-4" />

            <label for="selectMainProduct" class="form-label">VAT</label>
            <input disabled class="form-control mb-4" />

            <label for="selectMainProduct" class="form-label"
              >มูลค่าสุทธิ</label
            >
            <input disabled class="form-control" />
          </div>
        </div> -->
      </div>

      <!-- <div class="row d-flex justify-content-center">
        <div class="col-sm-10">
          <label for="retailPrice" class=" form-label col-sm-10">{{
            $t("โปรโมชั่น tier 1")
          }}</label>

          <select
            class="form-select mb-4"
            v-model="form.subProductGroupId1"
            id="validationTooltip01"
          >
            <option v-for="item in subProduct" :key="item" :value="item.id">
              {{ item.code }} |
              {{ item.sub_product_group_name }}
            </option>
          </select>
          <div class="invalid-feedback text-end">กรุณากรอก</div>
        </div>
      </div>

      <div class="row d-flex justify-content-center">
        <div class="col-sm-10">
          <label for="retailPrice" class=" form-label col-sm-10">{{
            $t("โปรโมชั่น tier 2")
          }}</label>

          <select
            class="form-select mb-4"
            v-model="form.subProductGroupId2"
            id="validationTooltip01"
          >
            <option v-for="item in subProduct" :key="item" :value="item.id">
              {{ item.code }} |
              {{ item.sub_product_group_name }}
            </option>
          </select>
          <div class="invalid-feedback text-end">กรุณากรอก</div>
        </div>
      </div>

      <div class="row d-flex justify-content-center">
        <div class="col-sm-10">
          <label for="retailPrice" class=" form-label col-sm-10">{{
            $t("โปรโมชั่น tier 3")
          }}</label>

          <select
            class="form-select mb-4"
            v-model="form.subProductGroupId3"
            id="validationTooltip01"
          >
            <option v-for="item in subProduct" :key="item" :value="item.id">
              {{ item.code }} |
              {{ item.sub_product_group_name }}
            </option>
          </select>
          <div class="invalid-feedback text-end">กรุณากรอก</div>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-sm-10">
          <label for="retailPrice" class=" form-label col-sm-10">{{
            $t("โปรโมชั่น tier 4")
          }}</label>

          <select
            class="form-select mb-4"
            v-model="form.subProductGroupId4"
            id="validationTooltip01"
          >
            <option v-for="item in subProduct" :key="item" :value="item.id">
              {{ item.code }} |
              {{ item.sub_product_group_name }}
            </option>
          </select>
          <div class="invalid-feedback text-end">กรุณากรอก</div>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-sm-10">
          <label for="retailPrice" class=" form-label col-sm-10">{{
            $t("โปรโมชั่น tier 5")
          }}</label>

          <select
            class="form-select mb-4"
            v-model="form.subProductGroupId5"
            id="validationTooltip01"
          >
            <option v-for="item in subProduct" :key="item" :value="item.id">
              {{ item.code }} |
              {{ item.sub_product_group_name }}
            </option>
          </select>
          <div class="invalid-feedback text-end">กรุณากรอก</div>
        </div>
      </div> -->

      <hr class="pt-0 mt-0" style="color: LightGrey" />

      <footer class="m-6">
        <div class="card-toolbar">
          <button
            type="button"
            class="btn btn-sm btn-light btn-primary me-2"
            style="font-size: 14px; font-weight: bold"
            @click="submit()"
          >
            บันทึก
          </button>
          <button
            type="button"
            class="btn btn-sm btn-light"
            style="font-size: 14px; font-weight: bold"
            @click="cancel"
          >
            ยกเลิก
          </button>
        </div>
      </footer>
    </form>
  </div>
</template>

<script>
import AddItem from "./components/dialogAddItem.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import whApi from "@/api/warehouse/";
import transferApi from "@/api/transfer/";
import DialogSearchProduct from "./components/dialogSearchProduct.vue";

export default {
  components: {
    AddItem,
    DialogSearchProduct,
  },
  setup() {
    document.title = "CHOMTHANA | สร้างใบโอนสินค้า";
  },
  data: () => ({
    searchProduct: "",
    isSubmit: false,
    isValidRetailPrice: false,
    dialogAddItem: false,
    form: {},
    ccsSelect: `background-size: 16px 12px;background-position: right 1rem center;background-repeat: no-repeat;background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%237E8299' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e")`,
    warehouses: [],
    dataItemsShow: [],
    subProduct: [],
    dialogSearchProduct: false,
  }),

  created() {
    this.getOne();
  },
  methods: {
    async getOne() {
      this.loading = true;
      let getOneResponse = {};
      try {
        getOneResponse = await whApi.itemGroup.getOne(this.$route.query.id);
      } catch (error) {
        console.log(error);
      }
      if (getOneResponse.response_status === "SUCCESS") {
        this.form = {
          ...getOneResponse.data,
        };
        this.dataItemsShow = getOneResponse.data.products;
        this.loading = false;
        console.log("getOneResponse.data", getOneResponse.data);
      }
    },
    addProduct(item) {
      console.log("addProduct", item);
      this.dataItemsShow.push(item);
    },
    async getAllWarehouse() {
      let responseData = [];
      try {
        responseData = await whApi.warehouse.getAll();
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.warehouses = responseData.data;
      }
    },
    async submit() {
      Swal.fire({
        icon: "question",
        title: `${this.$t("want2submit")} ${this.$t("ornot")} ?`,
        confirmButtonText: `${this.$t("ok")} `,
        cancelButtonText: `${this.$t("cancel")} `,
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.validateForm();
          await this.checkFormIsEmpty();
          if (this.isValid) {
            this.isSubmit = true;
            let responseData = [];
            let body = {
              ...this.form,
              products: this.dataItemsShow,
              companyId: parseInt(localStorage.getItem("companyId")),
            };

            try {
              responseData = await whApi.itemGroup.update(
                this.$route.query.id,
                body
              );
            } catch (error) {
              console.log(error);
            }
            if (responseData.response_status === "SUCCESS") {
              // this.productstock = responseData.data[0];
              // await this.submittransaction();
              Swal.fire({
                icon: "success",
                title: "แก้ไขข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
              }).then(() => {
                this.$router.go(-1);
              });
            } else {
              Swal.fire({
                icon: "error",
                title: responseData.message,
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
              });
            }
          }
        }
      });
    },
    async submittransaction() {
      let responseData = [];
      let body = {
        transaction_number: "",
        form_warehouse_id: this.form.fromWarehouseId,
        to_warehouse_id: this.form.toWarehouseId,
        products: this.dataItemsShow,
        remark: this.form.remark,
      };
      try {
        responseData = await transferApi.transfer.create(body);
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        // this.productstock = responseData.data[0];
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        }).then(() => {
          this.$router.go(-1);
        });
      }
    },

    cancel() {
      this.$router.go(-1);
    },
    addItem() {
      this.dialogAddItem = true;
    },
    closeDialogAddItem() {
      this.dialogAddItem = false;
    },

    async confirmDelete(item, index) {
      console.log("item", item);
      Swal.fire({
        icon: "question",
        title: `${this.$t("want2delete")} ${
          item.product ? item.product.code : item.code
        } ${this.$t("ornot")} ?`,
        confirmButtonText: `${this.$t("ok")} `,
        cancelButtonText: `${this.$t("cancel")} `,
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.dataItemsShow.splice(index, 1);
          // let deleteResponse = [];
          // deleteResponse = await whApi.warehouse.delete(item.id);
          // if (deleteResponse.response_status === "SUCCESS") {
          //   Swal.fire({
          //     icon: "success",
          //     title: "ลบสำเร็จ",
          //     showConfirmButton: false,
          //     timer: 1500,
          //   }).then(() => {
          //     this.dataItemsShow.splice(index, 1);
          //     this.tableItems.splice(index, 1);
          //     this.getAll(1);
          //   });
          // }
        }
      });
    },
    openDialogSearchProcuct() {
      this.dialogSearchProduct = true;
    },
    closeDialogSearchProduct() {
      this.dialogSearchProduct = false;
    },
    submitSearchProduct(item) {
      console.log("addProduct", item);
      this.dataItemsShow.push(item);
    },
    checkFormIsEmpty() {
      !this.form.code
        ? (this.isValid = false)
        : !this.form.name
        ? (this.isValid = false)
        : (this.isValid = true);
    },
    validateForm() {
      let forms = document.querySelectorAll(".needs-validation");
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            event.preventDefault();
            if (!form.checkValidity()) {
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
  },
};
</script>
